import React, { useEffect, useState } from 'react'

import Icon from '@public/images/scroll-up.svg'

import { ScrollButton } from './styles'

export function UpToScroll() {
  const [isVisible, setIsVisible] = useState(false)

  const toggleVisibility = () => {
    window.pageYOffset > 300 ? setIsVisible(true) : setIsVisible(false)
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility)
    return () => {
      window.removeEventListener('scroll', toggleVisibility)
    }
  }, [])

  return (
    <ScrollButton
      id="scroll_button"
      visibility={isVisible ? 'true' : undefined}
      onClick={scrollToTop}
    >
      <Icon alt="scroll-up" />
    </ScrollButton>
  )
}
